import CustomDomainPage from "components/Features/SingleFeaturePages/CustomDomain";

export default CustomDomainPage;
